import type { STDocument } from '@st/sdk'
import { match } from '@st/pattern'
import { renderDefaultDocumentViewerTopBar } from './top-bar'
import type { DocumentView } from '../types'

export function defaultDocumentView({
  document
}: {
  document: STDocument
}): DocumentView {
  return {
    pageGroups: () => document.pageGroups,
    viewerOptions: () => ({
      readOnly: false,
      annotationToolsEnabled: true,
      pageGroupMode: match(document.documentTypeId)
        .with('stanfordtax', () => 'hidden' as const)
        .otherwise(() => 'hint' as const)
    }),
    renderTopBar: (props) => renderDefaultDocumentViewerTopBar(document, props),
    renderSidebar: ({ fallback }) => fallback
  }
}
